import { render, staticRenderFns } from "./GymSalesTable.vue?vue&type=template&id=bbcabd1e"
import script from "./GymSalesTable.vue?vue&type=script&lang=js"
export * from "./GymSalesTable.vue?vue&type=script&lang=js"
import style0 from "./GymSalesTable.vue?vue&type=style&index=0&id=bbcabd1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports